import { render, staticRenderFns } from "./NoticeBell.vue?vue&type=template&id=1ab9d190&scoped=true"
import script from "./NoticeBell.vue?vue&type=script&lang=js"
export * from "./NoticeBell.vue?vue&type=script&lang=js"
import style0 from "./NoticeBell.vue?vue&type=style&index=0&id=1ab9d190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab9d190",
  null
  
)

export default component.exports